import { protectedFetch } from '../../utils/authSession';
import { isDirectHttpsAssetUrl } from './readingAssetUrl';

const objectUrlByApiUrl = new Map<string, string>();
const inflightByApiUrl = new Map<string, Promise<string>>();

export function peekReadingPagePreviewUrl(apiUrl: string | null | undefined): string | null {
  const key = String(apiUrl || '').trim();
  if (!key) return null;
  if (isDirectHttpsAssetUrl(key)) return key;
  return objectUrlByApiUrl.get(key) ?? null;
}

export async function resolveReadingPagePreviewUrl(apiUrl: string): Promise<string> {
  const key = apiUrl.trim();
  if (!key) throw new Error('Pratonton halaman tidak tersedia.');
  if (isDirectHttpsAssetUrl(key)) return key;
  const cached = objectUrlByApiUrl.get(key);
  if (cached) return cached;
  const pending = inflightByApiUrl.get(key);
  if (pending) return pending;

  const task = (async () => {
    const res = await protectedFetch(key, { headers: { Accept: 'image/*' } });
    if (!res.ok) throw new Error(`preview fetch failed (${res.status})`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    objectUrlByApiUrl.set(key, objectUrl);
    return objectUrl;
  })().finally(() => {
    inflightByApiUrl.delete(key);
  });

  inflightByApiUrl.set(key, task);
  return task;
}

export function resetReadingPagePreviewCacheForTests(): void {
  for (const url of objectUrlByApiUrl.values()) {
    URL.revokeObjectURL(url);
  }
  objectUrlByApiUrl.clear();
  inflightByApiUrl.clear();
}
